import { batch } from 'react-redux'

import * as Model from 'api/model'
import GetChildLayers from 'config/GetChildLayers'
import getChildData from 'data/GetChildData'
import InfoPanelLegacy from 'drawer/tabs/info/panels/InfoPanelLegacy'
import { WHATS_HERE_LAYER_TITLEID } from 'drawer/tabs/info/WhatsHereUtils'
import PoziMap from 'map/map'
import { getVisibleLayers } from 'utils/MapUtils'

export const SET_CURRENT_TARGET = 'SET_CURRENT_TARGET'
export const SET_CURRENT_TARGET_WHATS_HERE = 'SET_CURRENT_TARGET_WHATS_HERE'
export const SET_CURRENT_TARGET_CHILDREN = 'SET_CURRENT_TARGET_CHILDREN'
export const SET_CURRENT_TARGET_INTERSECT_LAYERS = 'SET_CURRENT_TARGET_INTERSECT_LAYERS'
export const RESET_CURRENT_TARGET = 'RESET_CURRENT_TARGET'
export const MAP_LOADED = 'MAP_LOADED'
export const SET_MAP_X = 'SET_MAP_X'
export const SET_MAP_Y = 'SET_MAP_Y'
export const SET_MAP_Z = 'SET_MAP_Z'
export const MAP_CONTEXT_MENU = 'MAP_CONTEXT_MENU'

export const setCurrentTarget = currentTarget => {
  // console.log('dispatch currentTarget to state')
  return dispatch => {
    batch(() => {
      dispatch({
        type: SET_CURRENT_TARGET_CHILDREN,
        currentTargetChildren: null
      })
      dispatch({
        type: SET_CURRENT_TARGET_INTERSECT_LAYERS,
        currentTargetIntersectLayers: null
      })
      dispatch({
        type: SET_CURRENT_TARGET,
        currentTarget
      })
      if (currentTarget?.titleid === WHATS_HERE_LAYER_TITLEID) {
        dispatch({
          type: SET_CURRENT_TARGET_WHATS_HERE,
          currentTarget
        })
      }
    })

    setCurrentTargetChildren(dispatch, currentTarget)
    InfoPanelLegacy()
  }
}

// TODO: Move this somewhere else
function setCurrentTargetChildren (dispatch, currentTarget) {
  console.debug('setCurrentTargetChildren - currentTarget', currentTarget?.titleid, currentTarget)

  if (!currentTarget) {
    console.log('setCurrentTargetChildren - currentTarget not set')
    return
  }

  const { titleid } = currentTarget

  // console.debug('setCurrentTargetChildren', titleid, currentTarget)

  const currentTargetChildren = []
  const visibleLayers = getVisibleLayers()

  // Only find layers that the current target intersects with if we
  // have a 'Whats Here' action.
  // When, in the future we have 'advanced advanced' selection, we will
  // need to be smarter here.
  const findIntersectLayers = titleid === WHATS_HERE_LAYER_TITLEID

  // Exclude certain groups
  const excludeGroups = ['pozigeneral']

  const currentTargetIntersectLayers = findIntersectLayers
    ? visibleLayers.filter(layerConf =>
      layerConf.titleid !== currentTarget.titleid && // Don't include currentTarget
      (layerConf.queryable ?? true) && // Only use visible layers that are queryable
      !excludeGroups.includes(layerConf.groupid) && // Exclude certain groups
      !layerConf.preventClick && // This is generally a LGA boundary layer
      !layerConf.view?.sort && // Ignore 'Nearby ..' layers
      !layerConf.type.match(/mapbox|maplibre|vectortile|wms/i) // Do not include VectorTile or WMS layers
    )
    : []

  // If the user right-clicked on a feature, bring the layer of that feature to the top of the
  // results
  const clickedIntersectLayerTitleId = Model.get('app.map.click.titleid', null)
  if (clickedIntersectLayerTitleId) {
    // Find the index of the clicked layer
    const clickedLayerIndex = currentTargetIntersectLayers.findIndex(
      layerConf => layerConf.titleid === clickedIntersectLayerTitleId
    )

    if (clickedLayerIndex >= 0) {
      // Remove the clicked layer from the intersect layers and store in variable
      const clickedLayer = currentTargetIntersectLayers.splice(clickedLayerIndex, 1)[0]

      // and add it back to the top of the results
      currentTargetIntersectLayers.unshift(clickedLayer)
    }
  }

  // console.debug('setCurrentTargetChildren - clickedIntersectLayerTitleId', clickedIntersectLayerTitleId)

  // console.debug('setCurrentTargetChildren - currentTargetIntersectLayers', titleid, currentTargetIntersectLayers)

  const childLayers = GetChildLayers(currentTarget?.titleid)

  const targetLayers = [...currentTargetIntersectLayers, ...childLayers]

  let streetviewData

  for (const targetLayer of targetLayers) {
    // console.debug('SetCurrentTargetChildren', targetLayer.titleid, targetLayer.queryable)

    const data = getChildData(currentTarget, targetLayer)
    if (!data.typelower) {
      console.log('Invalid child record! Must have a valid type.', targetLayer.titleid, data)
      continue
    }

    if (targetLayer.titleid === 'streetview') {
      streetviewData = data
      continue
    }

    currentTargetChildren.push(data)
  }

  // Bring street view layer to the top
  if (streetviewData) {
    currentTargetChildren.unshift(streetviewData)
  }

  // console.debug('setCurrentTargetChildren - intersectLayers', titleid, currentTargetIntersectLayers)

  // TODO: move this to its own section
  dispatch({
    type: SET_CURRENT_TARGET_INTERSECT_LAYERS,
    currentTargetIntersectLayers
  })

  // console.debug('setCurrentTargetChildren - children', titleid, currentTargetChildren)

  dispatch({
    type: SET_CURRENT_TARGET_CHILDREN,
    currentTargetChildren
  })
}

export const resetCurrentTarget = currentTarget => {
  return dispatch => {
    dispatch({
      type: RESET_CURRENT_TARGET,
      currentTarget
    })
    PoziMap().unselectAllFeatures()
  }
}

export const setMapLoaded = bMapLoaded => ({
  type: MAP_LOADED,
  bMapLoaded
})

export const setMapX = x => ({
  type: SET_MAP_X,
  x
})

export const setMapY = y => ({
  type: SET_MAP_Y,
  y
})

export const setMapZ = z => ({
  type: SET_MAP_Z,
  z
})

export const clearMapContextMenu = () => ({
  type: MAP_CONTEXT_MENU,
  contextMenu: null
})

export const setMapContextMenu = contextMenu => ({
  type: MAP_CONTEXT_MENU,
  contextMenu
})
